export default __webpack_public_path__ + "static/media/logout.b3568484.svg";